import * as React from 'react'

function SvgFiTcAirplane(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 537.942 539.909'
      {...props}
    >
      <path
        d='M270.52 264.576c-9.867 0-17.93 7.755-18.425 17.5l-97.55-.181c-3.55.025-4.278 4.985-.4 5.65l101.1 5.806c3.319 4.885 8.921 8.1 15.275 8.1 6.341 0 11.93-3.201 15.25-8.075l101.55-5.831c3.878-.665 3.15-5.625-.4-5.65l-97.975.206c-.482-9.756-8.55-17.525-18.425-17.525z'
        fill='#fff'
      />
      <path
        d='M382.64 303.12c4.383.052 102.168.052 106.55 0 4.383-.052 5.828-6.697-.252-7.176l-44.447-2.125c-3.686-.67-4.028-2.28-4.293-4.367l-.505-25.223c0-3.888-7.429-3.961-7.429 0l-.505 25.223c-.264 2.087-.606 3.698-4.293 4.367l-44.573 2.125c-6.08.479-4.635 7.124-.252 7.176z'
        fillOpacity={0.603}
        filter='url(#fi_tc_airplane_svg__filter7320)'
        transform='matrix(.8 0 0 .8 -78 33)'
      />
      <path
        d='M228.112 272.601c3.506.042 81.734.042 85.24 0 3.506-.041 4.662-5.357-.202-5.74l-35.557-1.7c-2.95-.536-3.223-1.825-3.435-3.494l-.404-20.179c0-3.11-5.943-3.168-5.943 0l-.404 20.179c-.211 1.67-.485 2.958-3.434 3.494l-35.659 1.7c-4.864.383-3.708 5.699-.202 5.74z'
        fill='#fff'
      />
    </svg>
  )
}

export default SvgFiTcAirplane
